<template>
    <div class="calendar">
        <div class="calendar__inner">
            <div class="calendar__event-types calendar__event-types--mobile">
                <a href="?performanceType=public" class="calendar__event-type" :class="{ 'is-active': activePerformanceType === 'public' }"><svg v-if="activePerformanceType === 'public'" class="o-icon o-icon--tick"><use href="#tick"></use></svg> Public Events</a>
                <a href="?performanceType=school" class="calendar__event-type" :class="{ 'is-active': activePerformanceType === 'school' }"><svg v-if="activePerformanceType === 'school'" class="o-icon o-icon--tick"><use href="#tick"></use></svg> School Events</a>
            </div>

            <aside class="calendar__sidebar">
                <div class="calendar__sticky">
                    <div class="calendar__event-types calendar__event-types--desktop">
                        <a href="?performanceType=public" class="calendar__event-type" :class="{ 'is-active': activePerformanceType === 'public' }"><svg v-if="activePerformanceType === 'public'" class="o-icon o-icon--tick"><use href="#tick"></use></svg> Public Events</a>
                        <a href="?performanceType=school" class="calendar__event-type" :class="{ 'is-active': activePerformanceType === 'school' }"><svg v-if="activePerformanceType === 'school'" class="o-icon o-icon--tick"><use href="#tick"></use></svg> School Events</a>
                    </div>

                    <CalendarDatePicker
                        :events="filteredEvents"
                    />
                    <div class="calendar__filters">
                        <div class="calendar__filters--desktop">

                            <CalendarFilters
                                :events="events"
                            />
                        </div>
                        <div class="calendar__filters--mobile">
                            <button class="calendar__filters--button" @click="filtersDialogRef?.open()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_858_6797)">
                                        <path d="M15.0372 19.178C16.1177 19.178 17.0005 18.2951 17.0005 17.2147C17.0005 16.1407 16.1177 15.2579 15.0372 15.2579C13.9633 15.2579 13.0805 16.1407 13.0805 17.2147C13.0805 18.2951 13.9633 19.178 15.0372 19.178ZM15.0372 18.2424C14.464 18.2424 14.016 17.7878 14.016 17.2147C14.016 16.6349 14.464 16.1868 15.0372 16.1868C15.617 16.1868 16.065 16.6349 16.065 17.2147C16.065 17.7878 15.617 18.2424 15.0372 18.2424ZM13.6801 16.6283H4.01495C3.68553 16.6283 3.42859 16.8852 3.42859 17.2147C3.42859 17.5375 3.68553 17.7944 4.01495 17.7944H13.6801V16.6283ZM19.8138 16.6283H16.4933V17.7944H19.8138C20.1168 17.7944 20.3738 17.5375 20.3738 17.2147C20.3738 16.8852 20.1168 16.6283 19.8138 16.6283ZM8.92985 13.9798C10.0103 13.9798 10.8931 13.1035 10.8931 12.023C10.8931 10.9425 10.0103 10.0597 8.92985 10.0597C7.85595 10.0597 6.97311 10.9425 6.97311 12.023C6.97311 13.1035 7.85595 13.9798 8.92985 13.9798ZM8.92985 13.0508C8.35666 13.0508 7.90866 12.5896 7.90866 12.0165C7.90866 11.4367 8.35666 10.9887 8.92985 10.9887C9.50962 10.9887 9.95764 11.4367 9.95764 12.0165C9.95764 12.5896 9.50962 13.0508 8.92985 13.0508ZM3.9886 11.4367C3.68553 11.4367 3.42859 11.6936 3.42859 12.0165C3.42859 12.3459 3.68553 12.6028 3.9886 12.6028H7.49359V11.4367H3.9886ZM19.7875 11.4367H10.2936V12.6028H19.7875C20.1168 12.6028 20.3738 12.3459 20.3738 12.0165C20.3738 11.6936 20.1168 11.4367 19.7875 11.4367ZM15.0372 8.77498C16.1177 8.77498 17.0005 7.89214 17.0005 6.81165C17.0005 5.73776 16.1177 4.85492 15.0372 4.85492C13.9633 4.85492 13.0805 5.73776 13.0805 6.81165C13.0805 7.89214 13.9633 8.77498 15.0372 8.77498ZM15.0372 7.83944C14.464 7.83944 14.016 7.38484 14.016 6.81165C14.016 6.23188 14.464 5.78388 15.0372 5.78388C15.617 5.78388 16.065 6.23188 16.065 6.81165C16.065 7.38484 15.617 7.83944 15.0372 7.83944ZM13.6998 6.23847H4.01495C3.68553 6.23847 3.42859 6.49541 3.42859 6.82483C3.42859 7.14766 3.68553 7.40461 4.01495 7.40461H13.6998V6.23847ZM19.8138 6.23847H16.4208V7.40461H19.8138C20.1168 7.40461 20.3738 7.14766 20.3738 6.82483C20.3738 6.49541 20.1168 6.23847 19.8138 6.23847Z" fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_858_6797">
                                            <rect width="17.1429" height="14.356" fill="white" transform="translate(3.42859 4.82202)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                Filters
                            </button>
                            <Dialog ref="filtersDialogRef">
                                <CalendarFilters
                                    :events="events"
                                    @close="filtersDialogRef?.close()"
                                />
                            </Dialog>
                        </div>
                    </div>
                </div>
            </aside>
            <main class="calendar__list" id="#page-content">
                <template v-if="loading">
                    <Loading />
                </template>

                <template v-else-if="errorMessage" class="error-message">
                    <p>{{ errorMessage }}</p>
                </template>

                <template v-else>
                    <CalendarList
                        ref="calendarListRef"
                        :events="filteredEvents"
                        :selected-date="selectedDate"
                        @selectevent="selectedEvent = $event"
                    />
                </template>
            </main>
            <CalendarPopup
                :event="selectedEvent"
                :format-date="formatEventDateFull"
                :format-time="formatEventTime"
                @close="selectedEvent = null"
            />
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, ref, watch, computed } from 'vue';
import { startOfMonth, endOfMonth } from 'date-fns';
import { formatEventDateFull, formatEventTime } from '../utils/date-formatters.mjs';
import { useState } from '../services/stateful';
import CalendarList from './CalendarList.vue';
import CalendarPopup from './CalendarPopup.vue';
import CalendarFilters from './CalendarFilters.vue';
import CalendarDatePicker from './CalendarDatePicker.vue';
import Dialog from '../Dialog/Dialog.vue';
import getPerformances from '../services/get-performances.mjs';

const activePerformanceType = computed(() => {
    const type = new URLSearchParams(window.location.search).get('performanceType');
    return type === 'school' ? 'school' : 'public';
});

const events = ref([]);
const calendarListRef = ref(null);
const datePickerDialogRef = ref(null);
const filtersDialogRef = ref(null);

const selectedEvent = useState('Calendar.SelectedEvent', null);
const filteredEvents = useState('Calendar.FilteredEvents', []);
const selectedDate = useState('Calendar.SelectedDate', null);
const loading = useState('Calendar.Loading', true);
const errorMessage = useState('Calendar.ErrorMessage', null);
const activeMonth = useState('CalendarList.ActiveMonth', new Date());

watch(selectedDate, (date) => {
    if (date) {
        datePickerDialogRef.value?.close();
    }
});

watch(filteredEvents, (newFilteredEvents) => {
    if (!featureEnabled('calendar.paginated')) {
        return;
    }

    if (newFilteredEvents.length === 0) {
        return;
    }

    const monthStart = startOfMonth(activeMonth.value);
    const monthEnd = endOfMonth(activeMonth.value);

    const hasEventsInCurrentMonth = newFilteredEvents.some(event => {
        return event.startDate >= monthStart && event.startDate <= monthEnd;
    });

    if (!hasEventsInCurrentMonth) {
        const firstEvent = newFilteredEvents[0];
        if (firstEvent) {
            activeMonth.value = startOfMonth(firstEvent.startDate);
        }
    }
});

onBeforeMount(async () => {
    try {
        events.value = await getPerformances()
            .then(perfs => perfs.filter(p => !p.attributes.custom?.hide_from_calendar && !p.event.attributes.custom?.hide_from_calendar));
        filteredEvents.value = events.value;
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Something has gone wrong, please try again later.';
        events.value = [];
    } finally {
        loading.value = false;
    }
});
</script>
